"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleToggle = function handleToggle(_ref) {
  var isOn = _ref.isOn,
    isDisabled = _ref.isDisabled,
    onToggle = _ref.onToggle;
  return !isDisabled && onToggle(!isOn);
};
var ToggleButton = function ToggleButton(_ref2) {
  var isDisabled = _ref2.isDisabled,
    isOn = _ref2.isOn,
    uniqueID = _ref2.uniqueID,
    label = _ref2.label,
    onToggle = _ref2.onToggle,
    isSmall = _ref2.isSmall,
    tooltip = _ref2.tooltip;
  return _react.default.createElement("div", {
    className: "agillicToggleButton",
    "data-testid": uniqueID
  }, _react.default.createElement("button", {
    className: (0, _classnames.default)({
      disabled: isDisabled,
      small: isSmall,
      on: isOn
    }),
    id: uniqueID,
    onClick: function onClick() {
      return handleToggle({
        isOn: isOn,
        isDisabled: isDisabled,
        onToggle: onToggle
      });
    },
    disabled: isDisabled,
    title: tooltip,
    type: "button"
  }, _react.default.createElement("div", {
    className: "toggleSwitch"
  }, _react.default.createElement("div", {
    className: "toggleCircle"
  })), label && _react.default.createElement("label", {
    htmlFor: label
  }, label)));
};
ToggleButton.propTypes = {
  isOn: _propTypes.bool.isRequired,
  onToggle: _propTypes.func.isRequired,
  uniqueID: _propTypes.string.isRequired,
  tooltip: _propTypes.string,
  isDisabled: _propTypes.bool,
  label: _propTypes.string,
  isSmall: _propTypes.bool
};
var _default = ToggleButton;
exports.default = _default;